import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Container from '../../../containers/integration/menuItems/createMenuContainer';
import { actions } from '../../../redux/integration/menuItems';

export default function () {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actions.getInitData('\'\''));
  }, []);
  return (
    <Container />
  );
}
